export function assertTypeName(condition: boolean): asserts condition {
  if (!condition) {
    throw new TypeError("Invalid node type");
  }
}
